import { useCallback, useRef } from 'react'
import { useTable } from '@/hooks/useTable'
import { nextDocumentOrigin, type DocumentOrigin } from '../lib/nextDocumentOrigin'

/**
 * Keeps the origin quick filter in step with the free text: originals while a
 * boolean search is active, as `nextDocumentOrigin` decides. Call it with the text
 * on every change. Setting the column filter, not the URL, keeps the toggle showing
 * what is searched.
 */
export function useAutoDocumentOrigin(): (text: string) => void {
  const { table } = useTable()
  const autoSelected = useRef(false)

  return useCallback((text: string) => {
    const column = table.getColumn('documentOrigin')
    if (!column) {
      return
    }

    const value = column.getFilterValue()
    const only: unknown = Array.isArray(value) && value.length === 1 ? value[0] : undefined
    const origin: DocumentOrigin = only === 'core/factbox' || only === 'core/article'
      ? only
      : undefined
    const next = nextDocumentOrigin({ text, origin, autoSelected: autoSelected.current })

    autoSelected.current = next.autoSelected
    if (next.origin !== origin) {
      column.setFilterValue(next.origin ? [next.origin] : undefined)
    }
  }, [table])
}
